var updateMiniBasket = function() {
    let p = $.ajax({
        url: '/ajax/component/maximaster:small.basket.widget/'
    });
    let p2 = $.ajax({
        url: '/ajax/component/maximaster:small.basket.widget/cart-preview/'
    });

    Promise.all([p, p2]).then(function(data) {
        let selectors = ['.js-cart-preview-head', '.js-cart-preview'];
        for (let i in selectors) {
            let html = data[i]['html'];
            if (html) {
                $(selectors[i]).html(html);
            }
        }
    });
};

window.updateMiniBasket = updateMiniBasket;



// WEBPACK FOOTER //
// ./blocks/mini-cart.js